import Typography from '@material-ui/core/Typography';
import React from 'react';
import { connectHighlight } from 'react-instantsearch-dom';

const Highlight = ({ highlight, attribute, hit, className, align, noWrap, variant }) => {
  const parsedHit = highlight({ highlightProperty: '_highlightResult', attribute, hit });
  return (
    <Typography className={className} align={align} noWrap={noWrap} variant={variant}>
      {parsedHit.map((part, index) => {
        return part.isHighlighted ? (
          <mark key={index}>{part.value}</mark>
        ) : (
          <span key={index}>{part.value}</span>
        );
      })}
    </Typography>
  );
};

export default connectHighlight(Highlight);